import {
  ReportResearchFilter,
  ReportResearchFilterProps,
} from './report-research-filter';
import { CloseIcon, FilterIcon } from '@snapi/icons';
import { useToggle } from 'react-use';
import { AnimatePresence, motion } from 'framer-motion';

export const SideOverOverlay = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

export function ReportResearchFilterModal(props: ReportResearchFilterProps) {
  const [open, setOpen] = useToggle(false);

  return (
    <>
      <FilterIcon onClick={setOpen} className="text-blue-dark"/>
      <AnimatePresence>
        {open && (
          <motion.div
            variants={SideOverOverlay}
            transition={{ duration: 0.6 }}
            initial="hidden"
            animate={open ? 'visible' : 'hidden'}
            className="fixed top-0 bottom-0 left-0 z-20 flex justify-center w-full"
          >
            <div className="absolute bg-dark opacity-50 top-0 left-0 right-0 bottom-0" />
            <div className="relative z-10" role="dialog" aria-modal="true">
              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <div className="relative bg-white rounded-lg transform transition-all sm:my-8 sm:max-w-sm sm:p-6">
                    <span className="absolute right-4 top-4">
                      <CloseIcon onClick={setOpen} />
                    </span>
                    <ReportResearchFilter {...props} />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
